import { useEffect, useState } from "react";
import axios from "axios";
import { DataGrid, Progress } from "..";
import { Alert } from "@mui/material";

const renderResponse = (res) => {
  if (res.error) {
    return <Alert severity="error">{res.error}</Alert>;
  }

  const columns = [
    {
      field: "name",
      headerName: "Newsletter Name",
      flex: 1,
    },
    {
      field: "subscriptions",
      headerName: "Subscriptions",
      flex: 1,
    },
  ];

  const resultColumns = Object.keys(res.fields).map((name) => ({
    field: name,
    headerName: name,
    flex: 1,
  }));

  let total = 0;

  const results = res.lists.map((list) => {
    total += list.new;

    return {
      ...list,
      subscriptions: list.new,
    };
  });

  results.push({
    style: "total",
    name: "Total",
    subscriptions: total,
  });

  return (
    <div>
      Rows in CSV: {res.row_count}
      <br />
      Total Subscriptions: {res.total_subscriptions}
      <br />
      <h2>Newsletter Subscriptions</h2>
      <DataGrid rows={results} columns={columns} />
      <br />
      <h2>Subscriptions to Update</h2>
      <DataGrid rows={res.results} columns={resultColumns} />
    </div>
  );
};

export const PrepareSubscriptions = ({
  selectedFile,
  onSetResults,
  setNextStepDisabled,
}) => {
  const [loading, setLoading] = useState(true);
  const [response, setResponse] = useState(null);

  useEffect(() => {
    if (!selectedFile) {
      setLoading(false);
      setResponse({ error: "Please select a file" });
      onSetResults([]);
      return;
    }

    const formData = new FormData();
    formData.append("upload", selectedFile, selectedFile.name);

    setLoading(true);
    axios
      .post(
        `${process.env.REACT_APP_BACKEND_API}/prepareSubscriptions`,
        formData
      )
      .then((response) => response.data)
      .then((data) => {
        setResponse(data);
        setNextStepDisabled(false);
        onSetResults({ toLoad: data.results, lists: data.lists });
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        onSetResults([]);
        setResponse({ error: error.message });
      });
  }, [selectedFile, onSetResults, setNextStepDisabled]);

  if (loading)
    return (
      <Progress text="Running Subscription Status Checks (Please get coffee at we run around 70 checks/second)" />
    );

  return response ? renderResponse(response) : "";
};
